import React, { useCallback, useEffect, useState } from 'react';
import { TVisibilityCond } from '../types';
import { IFNTheme, registerClass } from '@food/css-manager';
import { useHistory } from 'react-router';
import { parse } from 'url';
import { hash, setLocalAchievement } from '../utils/misc';
import ReactGA from 'react-ga';
import { isLogged } from '@food/auth/build/dist/logic/auth';
import { client } from './apps/ReservedContent';
import { saveAchievementMutation } from '../utils/achievements';

const styleClass = registerClass(
	(t: IFNTheme) => `

	padding-left: ${t.font.baseSize * t.ratios.l}px;
	padding-right: ${t.font.baseSize * t.ratios.l}px;

	iframe {
		width: 100%;
		display: block;
		min-height: 300px;
	}
`,
);

export const PardotForm: React.FC<{ condition: TVisibilityCond }> = ({ condition }) => {
	const [iframeHeight, updateIframeHeight] = useState<number>(0);
	const history = useHistory();

	if (condition.type !== 'PARDOT') {
		throw new Error('ERRORE');
	}

	const callback = useCallback((event) => {
		const parsedUrl = parse(condition.url);
		if (event.origin === parsedUrl.protocol + '//' + parsedUrl.host) {
			if (event.data.submit) {
				const achievement = 'pardot:' + hash(condition.url);

				// imposto la voce nel localstorage, sempre utile per velocizzare i controlli
				setLocalAchievement(achievement);

				// siccome pardot viene usato per iscrizioni alle newsletter, segnalo l'evento ad analytics
				ReactGA.event({
					category: 'User',
					action: 'Subscription to newsletter',
				});

				// se sono loggato vado anche a segnare l'achievement sul mio account
				if (isLogged()) {
					client.mutate({
						mutation: saveAchievementMutation,
						variables: { achievement },
					});
				}

				// torno alla pagina principale per eseguire nuovamente i controlli
				history.replace('/');
			} else if (typeof event.data === 'number') {
				updateIframeHeight(event.data);
			}
		}
	}, []);

	useEffect(() => {
		window.addEventListener('message', callback);
		return () => window.removeEventListener('message', callback);
	}, []);

	return (
		<div className={styleClass}>
			<iframe style={{ height: iframeHeight + 'px' }} src={condition.url} />
		</div>
	);
};
